<template lang="html">
  <div @click="checkClick($event)" class="modal-overlay">
    <transition name="component-fade" mode="out-in" appear>
      <component
        :is="component"
        @changeModal="$emit('changeModal', $event)"
        :modalData="modalData"
      />
    </transition>
  </div>
</template>

<script>
import registerBusinessModal from "@/components/modals/registerBusinessModal.vue";
import registerStandardModal from "@/components/modals/registerStandardModal.vue";
import chooseRegistrationModal from "@/components/modals/chooseRegistrationModal.vue";
import mySellersSellerHistory from "@/components/modals/mySellersSellerHistory.vue";
import myBuyersBuyerHistory from "@/components/modals/myBuyersBuyerHistory.vue";
import productBuyers from "@/components/modals/productBuyers.vue";
import NewsDescription from "@/components/modals/NewsDescription.vue";
import buyerDetails from "@/components/modals/buyerDetails.vue";
import addCodebook from "@/components/modals/addCodebook.vue";
import removeCodebook from "@/components/modals/removeCodebook.vue";
import confirmModal from "@/components/modals/confirmModal.vue";
import confirmVoteModal from "@/components/modals/confirmVoteModal.vue";
import confirmYesNoModal from "@/components/modals/confirmYesNoModal.vue";
import messageModal from "@/components/modals/messageModal.vue";
import changeUserPass from "@/components/modals/changeUserPass.vue";
import singleSugestion from "@/components/modals/singleSugestion.vue";
import editDocument from "@/components/modals/editDocument.vue";
import addDocument from "@/components/modals/addDocument.vue";
import addGroup from "@/components/modals/addGroup.vue";
import addImage from "@/components/modals/addImage.vue";
import questionmarkModal from "@/components/modals/questionmarkModal.vue";
import newNews from "@/components/modals/newNews.vue";
import editGroupModal from "@/components/modals/editGroupModal.vue";
import changeGroupModal from "@/components/modals/changeGroupModal.vue";
import changePromotionModal from "@/components/modals/changePromotionModal.vue";
import editTutorial from "@/components/modals/editTutorial.vue";
import signInMod from "@/components/modals/signInMod.vue";
import changeOffer from "@/components/modals/changeOffer.vue";
import userCancellations from "@/components/modals/userCancellations.vue";
import userRejections from "@/components/modals/userRejections.vue";
import productBuyings from "@/components/modals/buyings.vue";
import renewModal from "@/components/modals/renewModal.vue";
import addFaq from "@/components/modals/addFaq.vue";
import editFaqLocale from "@/components/modals/editFaqLocale.vue";
import imgSolution from "@/components/modals/imgSolution.vue";
import adminEditCategory from "@/components/modals/adminEditCategory.vue";
import addCodebookCategory from "@/components/modals/addCodebookCategory.vue";
import changeCompetitionStatusModal from "@/components/modals/changeCompetitionStatusModal.vue";
import editWorkPoints from "@/components/modals/editWorkPoints.vue";
import editWorkSetup from "@/components/modals/editWorkSetup.vue";
import competitionWorkInfo from "@/components/modals/competitionWorkInfo.vue";
import resetPasswordModal from "@/components/modals/resetPass/resetPasswordModal.vue";
import generateContract from "./modals/generateContract.vue";

export default {
  name: "modalWrapper",
  props: {
    component: {
      required: true,
      default: "registerModal"
    },
    modalData: {
      required: false
    },
    outsideClose: {
      default: true,
      type: Boolean
    }
  },
  components: {
    registerBusinessModal,
    registerStandardModal,
    chooseRegistrationModal,
    mySellersSellerHistory,
    myBuyersBuyerHistory,
    productBuyers,
    NewsDescription,
    buyerDetails,
    addCodebook,
    removeCodebook,
    confirmModal,
    confirmVoteModal,
    messageModal,
    changeUserPass,
    singleSugestion,
    editDocument,
    addDocument,
    addGroup,
    addImage,
    questionmarkModal,
    newNews,
    editGroupModal,
    changeGroupModal,
    changePromotionModal,
    editTutorial,
    signInMod,
    changeOffer,
    userCancellations,
    userRejections,
    renewModal,
    productBuyings,
    addFaq,
    editFaqLocale,
    imgSolution,
    adminEditCategory,
    addCodebookCategory,
    confirmYesNoModal,
    changeCompetitionStatusModal,
    editWorkPoints,
    editWorkSetup,
    competitionWorkInfo,
    resetPasswordModal,
    generateContract
  },
  methods: {
    checkClick(evt) {
      if (evt.target.classList.contains("modal-overlay") && this.outsideClose) {
        this.$emit("closeModal");
      }
    }
  },
  mounted() {
    let el = document.querySelector("html");
    el.style.overflow = "hidden";
  },
  destroyed() {
    let el = document.querySelector("html");
    el.style.overflow = "auto";
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
